import { ready } from '~/core';
import { addEvents } from '~/utils';



ready('smallChecks', '.smallChecks ', checks => {

    const triggers = [...checks.querySelectorAll('.smallChecks-check')];

    const prepare = trigger => {

       
	};

    triggers.forEach(trigger => prepare(trigger));


});